module.exports = __webpack_public_path__ + "static/media/before_after_1.e4526595.png";